@if (isOpen | async) {
  <div id="id-upload-modal">
    <div class="vtz-modal" id="submit-modal">
      @if (idUploadState.status !== 'error' && idUploadState.status !== 'rejected-passportNumber' && idUploadState.status !== 'rejected' && idUploadState.status !== 'success' && headshotUploadState.headshot_upload_error === '' && !headshotUploadState.valid_headshot) {
        <img i18n-alt="Voatz logo alt-text" alt="Voatz Logo" src="/assets/images/logo.svg" />
      }
      @if (isError()) {
        <img i18n-alt="icon alert alt-text" alt="icon alert" src="/assets/images/icon_fail.svg" />
      }
      @if (isSuccess()) {
        <img i18n-alt="icon checkmark alt-text" alt="icon checkmark" src="/assets/images/icon_success.svg" />
      }
      <div id="id-upload-modal-content" class="vtz-modal-content">
        @if (isError() && idUploadState.status !== 'rejected-passportNumber') {
          <span i18n class="vtz-modal-title">Upload Failed</span>
        }
        @if (idUploadState.status === 'rejected-passportNumber') {
          <span i18n class="vtz-modal-title">Passport Numbers do not match</span>
        }
        @if (isError()) {
          <span class="vtz-modal-body vtz-modal-body--narrow vtz-modal-body--medium">{{ getErrorMessage() }}</span>
        }
        @if (isSuccess()) {
          <span i18n class="vtz-modal-title">Upload Successful</span>
        }
        @if (isSuccess()) {
          <span class="vtz-modal-body vtz-modal-body--narrow vtz-modal-body--medium">{{ getSuccessMessage() }}</span>
        }
        @if (isLoading()) {
          <span i18n class="vtz-modal-body vtz-modal-body--narrow vtz-modal-body--medium">Your file is uploading. Please wait.</span>
        }
        @if (isLoading()) {
          <div id="id-upload-modal-loader" class="loader"></div>
        }
        @if (isLoading()) {
          <span i18n class="vtz-modal-body vtz-modal-body--narrow vtz-modal-body--medium">Please do not refresh your browser, or navigate away from this page, or you will have to start the upload process again.</span>
        }
      </div>
      <div id="id-upload-modal-buttons" class="button-group">
        @if (idUploadState.status === 'error' || idUploadState.status === 'rejected' || idUploadState.status === 'rejected-passportNumber' || headshotUploadState.headshot_upload_error !== '') {
          <button id="cancel-button" class="button-primary" (click)="ok()" i18n>OK</button>
        }
      </div>
    </div>
    <div id="id-upload-modal-backdrop" class="vtz-modal-backdrop"></div>
  </div>
}
